// extracted by mini-css-extract-plugin
export default {"layout":"Homepage_layout__z+WAc","section":"Homepage_section__Dd5ed","fade":"Homepage_fade__E2R-i","fadeIn":"Homepage_fadeIn__4jkcl","sidebar":"Homepage_sidebar__h9yut"};